import styled, { css } from 'styled-components'

export const Label = styled.label(
  ({ theme }) => css`
    position: absolute;
    left: 24px;
    top: -8px;

    color: ${theme.colors.grays.N500};
    background-color: #fff;
    padding: 0 8px;
    text-transform: uppercase;
    font-size: ${theme.fontSizes.label};
    font-weight: ${theme.fontWeights.extraBold};

    transition: color 0.2s;
  `,
)

export const ErrorText = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.error};
    font-size: ${theme.fontSizes[0]};
    line-height: 1em;
    position: absolute;
    bottom: -18px;
  `,
)

export const Input = styled.input(
  ({ theme, error }) => css`
    display: block;
    width: 100%;
    border: 1px solid;
    border-color: ${theme.colors.grays.N500};
    border-radius: 8px;
    padding: 12px 32px;
    transition: all 0.2s;
    font-family: ${theme.fonts.body};
    font-size: ${theme.fontSizes.body};
    color: ${theme.colors.text};

    /**
   * Focus State
   */
    :focus {
      border-color: ${theme.colors.primary};
      box-shadow: ${theme.shadows.under[1]};
    }

    :focus ~ ${Label} {
      color: ${theme.colors.primary};
    }

    /**
   * Disable State
   */
    :disabled {
      border-color: ${theme.colors.grays.N300};
      background-color: transparent;

      ::placeholder {
        color: ${theme.colors.grays.N300};
      }
    }

    :disabled ~ ${Label} {
      color: ${theme.colors.grays.N300};
    }

    /**
   * Error State
   */
    ${error &&
      css`
        &,
        :focus {
          border-color: ${theme.colors.error};
        }

        & ~ ${Label}, :focus ~ ${Label} {
          color: ${theme.colors.error};
        }
      `}
  `,
)
